var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.visible,
            title: "提示",
            width: "896px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("article-list", {
                attrs: {
                  couponId: _vm.couponId,
                  handle: _vm.handle,
                  keyNum: _vm.keyNum,
                  userIds: _vm.userIds,
                },
                on: { getArticle: _vm.getArticle },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }